import React from 'react'
import styled from 'styled-components'
import { colors } from '@/styles'

type Props = {
  bgcolor: string
  completed: number
}

const Container = styled.div`
  height: 12px;
  width: 100%;
  background: ${colors.grey88};
  border-radius: 6px;
  overflow: hidden;
`

const Filler = styled.div<{ completed: number; bgcolor: string }>`
  height: 12px;
  width: ${props => props.completed}%;
  background: ${props => props.bgcolor};
  border-radius: 6px 0 0 6px;
`

const Progressbar = ({ bgcolor, completed }: Props) => {
  return (
    <Container>
      <Filler bgcolor={bgcolor} completed={completed}></Filler>
    </Container>
  )
}

export default Progressbar
